/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Groupsmembercount2Inputs */

const en_groupsmembercount2 = /** @type {(inputs: Groupsmembercount2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} members`)
};

const de_groupsmembercount2 = /** @type {(inputs: Groupsmembercount2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} Mitglieder`)
};

/**
* | output |
* | --- |
* | "{count} members" |
*
* @param {Groupsmembercount2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const groupsmembercount2 = /** @type {((inputs: Groupsmembercount2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Groupsmembercount2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_groupsmembercount2(inputs)
	return de_groupsmembercount2(inputs)
});
export { groupsmembercount2 as "groupsMemberCount" }